export const INITIAL_PRICE_OPTION = 'Initial Price';
export const CUSTOM_PRICE = 'Custom Price';
export const CUSTOM_PRICE_LABEL = 'Custom Price Label';

export const PRICE_TYPE_OPTIONS = [INITIAL_PRICE_OPTION, CUSTOM_PRICE, CUSTOM_PRICE_LABEL];
